
import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import VueI18n from "vue-i18n";

@Component({
  name: 'HeaderStepTitle'
})
export default class HeaderStepTitle extends Vue {
  @Prop(String) readonly title!: string | VueI18n.TranslateResult
  @Prop(String) readonly desc!: string| VueI18n.TranslateResult
}
